module.exports = __webpack_public_path__ + "img/house-user.cb74f62b.svg";